import React from 'react';

import TicketList from '~/components/Workflow/WorkflowTicketsPage/TicketList';
import { withFlags } from '~/flags/withFlags';

const Page = (props: any) => {
  const TicketListComponent = withFlags(TicketList);

  // @ts-ignore
  return <TicketListComponent {...props} />;
};

export default Page;
